import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { Link, Navigate } from "react-router-dom";
import Axios from 'axios';
import Moment from 'react-moment';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { getInitials, showSortIcon, numberWithSpaces } from '../utilities/OtherUtilities.js';

// import assets
import icon_expand from '../assets/icon_expand.png';

// import components
import ProfileImageSmall from '../components/ProfileImageSmall.js';

class NewSubmissionFormTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            statementName: "Loading statement name...",
            globalIsOpen: true,
        }

    }

    componentDidMount(){
        this.setState({ redirectTo: null });
        this.loadData();
    }

    componentDidUpdate(prevProps){
        if(this.props.statTpId !== prevProps.statTpId){
            this.loadData();
        }
    }

    loadData = async () => {
        await this.loadStatementName();
    }

    loadStatementName = () => {
        Axios.get('/api/stmt_tp/get').then(response => {
            this.setState({ listOfStatType: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            for(let oneRow of response.data.result){
                if(oneRow.id == this.props.statTpId){
                    this.setState({ statementName: oneRow.label });
                }
            }
        });
    }

    onAmountChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.amount = newValue; } }
        this.props.setListOfCategories(newArray);
    }

    onExplanationChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.explanation = newValue; } }
        this.props.setListOfCategories(newArray);
    }

    onVarExplanationChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.var_explanation = newValue; } }
        this.props.setListOfCategories(newArray);
    }

    onCenterOneChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_one = newValue; } }
        this.props.setListOfCategories(newArray);

        this.countAndUpdateCenterSix(idCategory);
    }

    onCenterTwoChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_two = newValue; } }
        this.props.setListOfCategories(newArray);

        this.countAndUpdateCenterSix(idCategory);
    }

    onCenterThreeChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_three = newValue; } }
        this.props.setListOfCategories(newArray);

        this.countAndUpdateCenterSix(idCategory);
    }

    onCenterFourChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_four = newValue; } }
        this.props.setListOfCategories(newArray);

        this.countAndUpdateCenterSix(idCategory);
    }

    onCenterFiveChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_five = newValue; } }
        this.props.setListOfCategories(newArray);

        this.countAndUpdateCenterSix(idCategory);
    }

    onCenterSixChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.center_six = newValue; } }
        this.props.setListOfCategories(newArray);
    }

    countAndUpdateCenterSix = (idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){
            if(oneRow.id == idCategory){
                var newValue = oneRow.amount - oneRow.center_one - oneRow.center_two - oneRow.center_three - oneRow.center_four - oneRow.center_five;
                this.onCenterSixChanged(newValue, idCategory);
            }
        }

    }

    onIsOpenChanged = (newValue, idCategory) => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.is_open = newValue; } }
        this.props.setListOfCategories(newArray);
    }

    onGlobalIsOpenChanged = () => {
        var newArray = this.props.listOfCategories;
        for(let oneRow of newArray){ oneRow.is_open = !this.state.globalIsOpen; }

        this.props.setListOfCategories(newArray);
        this.setState({ globalIsOpen: !this.state.globalIsOpen});
    }

    hasChild = (idCategory) => {
        for(let oneRow of this.props.listOfCategories){
            if(oneRow.parent_id == idCategory) return true;
        }
        return false;
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }

        return (

            <div className="universalLeftTileWithTable" style={{marginTop: 20, marginBottom: 20}}>

                {/* FIRST STEP */}
                <div style={{display: this.props.showStep == 1 ? "" : "none"}}>
                    <span className="fontPoppinsSemiBold15 clickable">{this.state.statementName} (Step 1/3): Add & Explain Amounts</span>

                    <div className="horizontalStackCenter">

                            <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                                <tr>
                                    <td className="universalTableInLeftTileHeader clickable" nowrap="nowrap" onClick={() => this.onGlobalIsOpenChanged()}>
                                        <div>
                                            <img className={this.state.globalIsOpen ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginRight: 10}} src={icon_expand}/>
                                            Category
                                        </div>
                                    </td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Amount</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{width: "100%"}}>Explain Amount</td>
                                </tr>


                                {this.props.listOfCategories.map(function (item) {
                                    if(item.lvl == 1) return (
                                        <tbody>
                                        <tr className="clickable" key={item.id} style={{backgroundColor: "var(--gray-blue)"}}>
                                            <td nowrap="nowrap" style={{padding: 10}} className="clickable" onClick={() => this.onIsOpenChanged(!item.is_open,item.id)}>
                                                <div className="fontPoppinsRegular15">
                                                    <img className={item.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px",marginLeft: 5, marginRight: 10, visibility: this.hasChild(item.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                    {item.label}
                                                </div>
                                            </td>
                                            <td nowrap="nowrap" style={{padding: 10}}>
                                                <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "100px", marginBottom: 0, textAlign: "right"}} id="passAmountOne" name="passAmountOne" value={item.amount} onChange={e => this.onAmountChanged(e.target.value, item.id)} />
                                            </td>
                                            <td style={{padding: 10}} nowrap="nowrap">
                                                <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={item.explanation} onChange={e => this.onExplanationChanged(e.target.value, item.id)} />
                                            </td>
                                        </tr>
                                        <div style={{height: 2}}></div>

                                        {item.is_open && this.props.listOfCategories.map(function (secondItem) {
                                            if(secondItem.parent_id == item.id){
                                                return (
                                                    <React.Fragment>
                                                    <tr style={{backgroundColor: "var(--light-blue)"}}>
                                                        <td nowrap="nowrap" style={{padding: 10, fontSize: 13, paddingLeft: 15}} className="clickable" onClick={() => this.onIsOpenChanged(!secondItem.is_open,secondItem.id)}>
                                                            <div className="fontPoppinsRegular13">
                                                                <img className={secondItem.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginLeft: 5, marginRight: 10, visibility: this.hasChild(secondItem.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                                {secondItem.label}
                                                            </div>
                                                        </td>
                                                        <td style={{padding: 10}}>
                                                            <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "100px", marginBottom: 0, textAlign: "right"}} id="passAmountOne" name="passAmountOne" value={secondItem.amount} onChange={e => this.onAmountChanged(e.target.value, secondItem.id)} />
                                                        </td>
                                                        <td style={{padding: 10}}>
                                                            <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={secondItem.explanation} onChange={e => this.onExplanationChanged(e.target.value, secondItem.id)} />
                                                        </td>
                                                    </tr>
                                                    <div style={{height: 2}}></div>

                                                    {secondItem.is_open && this.props.listOfCategories.map(function (thirdItem) {
                                                        if(thirdItem.parent_id == secondItem.id) return (
                                                            <React.Fragment>
                                                            <tr style={{backgroundColor: "var(--lightest-blue)"}}>
                                                                <td style={{padding: 10, fontSize: 13, paddingLeft: 40}} nowrap="nowrap"><span className="fontPoppinsRegular13">{thirdItem.label}</span></td>
                                                                <td style={{padding: 10}}>
                                                                    <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "100px", marginBottom: 0, textAlign: "right"}} id="passAmountOne" name="passAmountOne" value={thirdItem.amount} onChange={e => this.onAmountChanged(e.target.value, thirdItem.id)} />
                                                                </td>
                                                                <td style={{padding: 10}}>
                                                                    <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={thirdItem.explanation} onChange={e => this.onExplanationChanged(e.target.value, thirdItem.id)} />
                                                                </td>
                                                            </tr>
                                                            <div style={{height: 2}}></div>
                                                            </React.Fragment>
                                                        )
                                                    }.bind(this))}

                                                    </React.Fragment>
                                                )


                                            }
                                        }.bind(this))}

                                        </tbody>
                                    )
                                }.bind(this))}
                            </table>

                    </div>
                </div>

                {/* SECOND STEP */}
                <div style={{display: this.props.showStep == 2 ? "" : "none"}}>
                    <span className="fontPoppinsSemiBold15 clickable">{this.state.statementName} (Step 2/3): Fill Cost-Centers</span>

                    <div className="horizontalStackCenter">

                            <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                                <tr>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap">Category</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{width: "100%", textAlign: "right"}}>Current Year</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Staff/Miss</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Progr-Evang</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Progr-Train</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Adm./Ops.</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Facil.&Bus.</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Other</td>
                                </tr>


                                {this.props.listOfCategories.map(function (item) {
                                    if(item.lvl == 1) return (
                                        <tbody>
                                        <tr className="clickable" key={item.id} style={{backgroundColor: "var(--gray-blue)"}}>
                                            <td nowrap="nowrap" style={{padding: 10}}><div className="fontPoppinsRegular15">{item.label}</div></td>
                                            <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount)} {this.props.currency}</span></td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterOne" name="passCenterOne" value={item.center_one} onChange={e => this.onCenterOneChanged(e.target.value, item.id)} /> </td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterTwo" name="passCenterTwo" value={item.center_two} onChange={e => this.onCenterTwoChanged(e.target.value, item.id)} /> </td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterThree" name="passCenterThree" value={item.center_three} onChange={e => this.onCenterThreeChanged(e.target.value, item.id)} /> </td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFour" name="passCenterFour" value={item.center_four} onChange={e => this.onCenterFourChanged(e.target.value, item.id)} /> </td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFive" name="passCenterFive" value={item.center_five} onChange={e => this.onCenterFiveChanged(e.target.value, item.id)} /> </td>
                                            <td style={{padding: 10}} nowrap="nowrap"> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterSix" name="passCenterSix" value={item.center_six} /> </td>
                                        </tr>
                                        <div style={{height: 2}}></div>

                                        {this.props.listOfCategories.map(function (secondItem) {
                                            if(secondItem.parent_id == item.id){
                                                return (
                                                    <React.Fragment>
                                                    <tr style={{backgroundColor: "var(--light-blue)"}}>
                                                        <td style={{padding: 10, fontSize: 13, paddingLeft: 15}} nowrap="nowrap">{secondItem.label}</td>
                                                        <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount)} {this.props.currency}</span></td>

                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterOne" name="passCenterOne" value={secondItem.center_one} onChange={e => this.onCenterOneChanged(e.target.value, secondItem.id)} /> </td>
                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterTwo" name="passCenterTwo" value={secondItem.center_two} onChange={e => this.onCenterTwoChanged(e.target.value, secondItem.id)} /> </td>
                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterThree" name="passCenterThree" value={secondItem.center_three} onChange={e => this.onCenterThreeChanged(e.target.value, secondItem.id)} /> </td>
                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFour" name="passCenterFour" value={secondItem.center_four} onChange={e => this.onCenterFourChanged(e.target.value, secondItem.id)} /> </td>
                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFive" name="passCenterFive" value={secondItem.center_five} onChange={e => this.onCenterFiveChanged(e.target.value, secondItem.id)} /> </td>
                                                        <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterSix" name="passCenterSix" value={secondItem.center_six} /> </td>
                                                    </tr>
                                                    <div style={{height: 2}}></div>

                                                    {this.props.listOfCategories.map(function (thirdItem) {
                                                        if(thirdItem.parent_id == secondItem.id) return (
                                                            <React.Fragment>
                                                            <tr style={{backgroundColor: "var(--lightest-blue)"}}>
                                                                <td style={{padding: 10, fontSize: 13, paddingLeft: 30}} nowrap="nowrap"><span className="fontPoppinsRegular13">{thirdItem.label}</span></td>
                                                                <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount)} {this.props.currency}</span></td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterOne" name="passCenterOne" value={thirdItem.center_one} onChange={e => this.onCenterOneChanged(e.target.value, thirdItem.id)} /> </td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterTwo" name="passCenterTwo" value={thirdItem.center_two} onChange={e => this.onCenterTwoChanged(e.target.value, thirdItem.id)} /> </td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterThree" name="passCenterThree" value={thirdItem.center_three} onChange={e => this.onCenterThreeChanged(e.target.value, thirdItem.id)} /> </td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFour" name="passCenterFour" value={thirdItem.center_four} onChange={e => this.onCenterFourChanged(e.target.value, thirdItem.id)} /> </td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterFive" name="passCenterFive" value={thirdItem.center_five} onChange={e => this.onCenterFiveChanged(e.target.value, thirdItem.id)} /> </td>
                                                                <td style={{padding: 10}}> <input className="universalTextInput inputNumberHideArrows" type="number" style={{width: "90px", marginBottom: 0, textAlign: "right"}} id="passCenterSix" name="passCenterSix" value={thirdItem.center_six} /> </td>
                                                            </tr>
                                                            <div style={{height: 2}}></div>
                                                            </React.Fragment>
                                                        )
                                                    }.bind(this))}

                                                    </React.Fragment>
                                                )


                                            }
                                        }.bind(this))}

                                        </tbody>
                                    )
                                }.bind(this))}
                            </table>

                    </div>
                </div>

                {/* THIRD STEP */}
                <div style={{display: this.props.showStep == 3 ? "" : "none"}}>
                    <span className="fontPoppinsSemiBold15 clickable">{this.state.statementName} (Step 3/3): Explain Variance with Previous Year</span>

                    <div className="horizontalStackCenter">

                            <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                                <tr>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap">Category</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Current Year</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Previous Year</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{textAlign: "right"}}>Variance</td>
                                    <td className="universalTableInLeftTileHeader" nowrap="nowrap" style={{width: "100%"}}>Explain Variance</td>
                                </tr>


                                {this.props.listOfCategories.map(function (item) {
                                    if(item.lvl == 1) return (
                                        <tbody>
                                        <tr className="clickable" key={item.id} style={{backgroundColor: "var(--gray-blue)"}}>
                                            <td nowrap="nowrap" style={{padding: 10}}><div className="fontPoppinsRegular15">{item.label}</div></td>
                                            <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount)} {this.props.currency}</span></td>
                                            <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount_prev_year)} {this.props.currency}</span></td>
                                            <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount - item.amount_prev_year)} {this.props.currency}</span></td>
                                            <td style={{padding: 10}} nowrap="nowrap">
                                                <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={item.var_explanation} onChange={e => this.onVarExplanationChanged(e.target.value, item.id)} />
                                            </td>
                                        </tr>
                                        <div style={{height: 2}}></div>

                                        {this.props.listOfCategories.map(function (secondItem) {
                                            if(secondItem.parent_id == item.id){
                                                return (
                                                    <React.Fragment>
                                                    <tr style={{backgroundColor: "var(--light-blue)"}}>
                                                        <td style={{padding: 10, fontSize: 13, paddingLeft: 15}} nowrap="nowrap">{secondItem.label}</td>
                                                        <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount)} {this.props.currency}</span></td>
                                                        <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount_prev_year)} {this.props.currency}</span></td>
                                                        <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount - secondItem.amount_prev_year)} {this.props.currency}</span></td>

                                                        <td style={{padding: 10}}>
                                                            <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={secondItem.var_explanation} onChange={e => this.onVarExplanationChanged(e.target.value, secondItem.id)} />
                                                        </td>
                                                    </tr>
                                                    <div style={{height: 2}}></div>

                                                    {this.props.listOfCategories.map(function (thirdItem) {
                                                        if(thirdItem.parent_id == secondItem.id) return (
                                                            <React.Fragment>
                                                            <tr style={{backgroundColor: "var(--lightest-blue)"}}>
                                                                <td style={{padding: 10, fontSize: 13, paddingLeft: 30}} nowrap="nowrap"><span className="fontPoppinsRegular13">{thirdItem.label}</span></td>
                                                                <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount)} {this.props.currency}</span></td>
                                                                <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount_prev_year)} {this.props.currency}</span></td>
                                                                <td nowrap="nowrap" style={{textAlign: "right", paddingRight: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount - thirdItem.amount_prev_year)} {this.props.currency}</span></td>
                                                                <td style={{padding: 10}}>
                                                                    <input className="universalTextInput" type="text" style={{width: "100%", marginBottom: 0}} id="passExplanationOne" name="passExplanationOne" value={thirdItem.var_explanation} onChange={e => this.onVarExplanationChanged(e.target.value, thirdItem.id)} />
                                                                </td>
                                                            </tr>
                                                            <div style={{height: 2}}></div>
                                                            </React.Fragment>
                                                        )
                                                    }.bind(this))}

                                                    </React.Fragment>
                                                )


                                            }
                                        }.bind(this))}

                                        </tbody>
                                    )
                                }.bind(this))}
                            </table>

                    </div>
                </div>

            </div>

        );
    }
}

export default NewSubmissionFormTile;
